import { render, staticRenderFns } from "./TillageTab.vue?vue&type=template&id=7f30fca6&scoped=true&"
import script from "./TillageTab.vue?vue&type=script&lang=js&"
export * from "./TillageTab.vue?vue&type=script&lang=js&"
import style1 from "./TillageTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f30fca6",
  null
  
)

export default component.exports